import React from 'react';
import { ResetPasswordForm } from './components/reset-password-form';
import { useSelector } from 'react-redux';
import { selectSettings } from 'app/slice/selectors';
import { mediaBaseUrl } from 'utils/api/endpoints';

const ResetPasswordPage = () => {
  const settings = useSelector(selectSettings);
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-gray-50">
      <div className="max-w-md w-full space-y-8 bg-white dark:bg-transparent p-8 rounded-2xl">
        <div className="text-center">
          <img
            src={`${mediaBaseUrl}/site/${settings?.options?.logo}`}
            alt={settings?.site_name}
            className="max-w-[110px] mx-auto mb-4"
          />
          <h2 className="text-2xl font-semibold tracking-tight text-gray-900 mb-2">
            Reset Password
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Enter your new password below.
          </p>
        </div>
        <ResetPasswordForm />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
